module.exports = __webpack_public_path__ + "assets/img/warrior-name-bf47b609.png";